import { z } from "zod";

export const bookmarkLabelSchema = z
  .string()
  .trim()
  .min(1, "Enter a bookmark label.")
  .max(160, "Keep the bookmark label under 160 characters.");

export const bookmarkLinkSchema = z
  .string()
  .trim()
  .min(1, "Enter a bookmark link.")
  .max(2_048, "Keep the bookmark link under 2,048 characters.")
  .refine((value) => {
    if (/\s/u.test(value)) return false;
    try {
      const url = new URL(value);
      return (url.protocol === "http:" || url.protocol === "https:") && Boolean(url.hostname);
    } catch {
      return false;
    }
  }, "Enter a complete http or https link without spaces.");

export const bookmarkInputSchema = z
  .object({
    label: bookmarkLabelSchema,
    link: bookmarkLinkSchema,
  })
  .strict();

export const bookmarkIdParamsSchema = z.object({ bookmarkId: z.uuid() }).strict();

export const bookmarkSchema = z
  .object({
    id: z.uuid(),
    label: z.string(),
    link: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
  })
  .strict();

export const bookmarksResponseSchema = z.object({ bookmarks: z.array(bookmarkSchema) }).strict();
export const bookmarkMutationResponseSchema = z.object({ bookmark: bookmarkSchema }).strict();
export const deleteBookmarkResponseSchema = z.object({ deletedBookmarkId: z.uuid() }).strict();

export type BookmarkInput = z.infer<typeof bookmarkInputSchema>;
export type Bookmark = z.infer<typeof bookmarkSchema>;
export type BookmarksResponse = z.infer<typeof bookmarksResponseSchema>;
export type BookmarkMutationResponse = z.infer<typeof bookmarkMutationResponseSchema>;
export type DeleteBookmarkResponse = z.infer<typeof deleteBookmarkResponseSchema>;
